import { render, staticRenderFns } from "./sendBrokerStatementModal.vue?vue&type=template&id=622a13a8&scoped=true&"
import script from "./sendBrokerStatementModal.vue?vue&type=script&lang=js&"
export * from "./sendBrokerStatementModal.vue?vue&type=script&lang=js&"
import style0 from "./sendBrokerStatementModal.vue?vue&type=style&index=0&id=622a13a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622a13a8",
  null
  
)

export default component.exports